module.exports = __webpack_public_path__ + "img/intro2.b06c0354.png";